var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scoped-chip d-inline-flex px-3 background lighten-1 semi-bold"},[_c('div',{staticClass:"my-auto"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }